import React from 'react';
import { useSelector } from 'react-redux';

import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';

export const DetailManifest = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['{ Suspense }.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  return (
    <section className="pt-2 mb-3" id="manifest">
      {StateLoading ? (
        <div style={{ width: 250 }}>
          <SkeletonText count={1} />
        </div>
      ) : (
        <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
          Informasi Manifest
        </div>
      )}

      <div className="row mb-4">
        <div className="col-12">
          {StateLoading ? (
            dummy?.map((d, i) => (
              <ListHorizontal
                key={i}
                title={<SkeletonText count={1} />}
                content={<SkeletonText count={1} />}
              />
            ))
          ) : (
            <>
              {data?.shipping_method && (
                <ListHorizontal
                  title="Tipe Dispatch"
                  content={data?.shipping_method}
                />
              )}
              {data?.moda_type && (
                <ListHorizontal
                  title="Moda"
                  content={data?.moda_type.replaceAll('_', ' ')}
                />
              )}

              {data?.vendor && (
                <ListHorizontal title="Vendor" content={data?.vendor?.name} />
              )}

              {data?.vehicle_type && (
                <ListHorizontal
                  title="Jenis Kendaraan"
                  content={data?.vehicle_type?.name}
                />
              )}

              {data?.vendor_service_type && (
                <ListHorizontal
                  title="Vendor Tipe Layanan"
                  content={data?.vendor_service_type?.name}
                />
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
};
